import React, { useState } from "react";
import { Card, Input, Button, Typography, message } from "antd";

const { Title, Text } = Typography;

export default function Forgotpass() {
  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendOTP = async () => {
    if (!mobile) {
      return message.error("Enter mobile number");
    }

    try {
      setLoading(true);

      // API CALL
      // await axios.post("/api/send-otp", { mobile });

      setOtpSent(true);
      message.success("OTP sent successfully");
    } catch (error) {
      message.error("Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
      }}
    >
      <Card
        style={{
          width: 500,
          borderRadius: 16,
        }}
      >
        <div style={{ marginBottom: 25 }}>
          <Title level={2} style={{ marginBottom: 5 }}>
            Forgot Password
          </Title>

          <Text type="secondary">
            Enter your mobile number and we'll send an OTP.
          </Text>
        </div>

        <Input
          size="large"
          placeholder="Enter Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          maxLength={10}
          style={{
            height: 52,
            borderRadius: 10,
            marginBottom: 20,
          }}
        />

        <Button
          type="primary"
          size="large"
          loading={loading}
          onClick={sendOTP}
          block
          style={{
            height: 52,
            borderRadius: 10,
            background: "#ff5722",
            border: "none",
            fontWeight: 600,
          }}
        >
          Send OTP
        </Button>

        {otpSent && (
          <div
            style={{
              marginTop: 25,
              textAlign: "center",
              color: "#52c41a",
            }}
          >
            OTP sent to {mobile}
          </div>
        )}

        <div
          style={{
            marginTop: 25,
            textAlign: "center",
          }}
        >
          <a href="/login">
            ← Back to Login
          </a>
        </div>
      </Card>
    </div>
  );
}